import { cn } from '@/utils/cn'
import { Button } from '../common/button'
import { Popover, PopoverContent, PopoverList, PopoverListItem, PopoverTrigger } from '../common/popover'
import { ArrowIcon } from '../icons/arrow'
import { CheckIcon } from '../icons/check'

export type PresetKey = 'all' | 'tvl' | 'eth' | 'usd'

export interface VaultPresetsProps {
  presets: PresetKey[]
  activePreset: PresetKey
  onPresetClick: (key: PresetKey) => void
}

export const VaultPresetSelector = ({ presets, activePreset, onPresetClick }: VaultPresetsProps) => {
  const activePresetElement = presets.find((preset) => preset === activePreset) ?? presets[0]

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="default" size="default" className="group gap-1">
          {getPresetDisplayName(activePresetElement)}
          <div className="group-data-[state=open]:-scale-y-100 transition-transform">
            <ArrowIcon direction="down" size={20} />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56">
        <PopoverList>
          {presets.map((preset) => (
            <PopoverListItem key={preset} className="border-t first:border-none">
              <Button
                variant="default"
                onClick={() => onPresetClick(preset)}
                className={cn('flex h-10 w-full max-w-full justify-between truncate px-4', 'hocus-within:bg-surface')}
              >
                <div className="flex w-full max-w-full items-center justify-between gap-2 truncate">
                  {getPresetDisplayName(preset)}
                  <CheckIcon
                    size={20}
                    className={cn('text-success transition-colors', activePreset !== preset && 'opacity-0')}
                  />
                </div>
              </Button>
            </PopoverListItem>
          ))}
        </PopoverList>
      </PopoverContent>
    </Popover>
  )
}

function getPresetDisplayName(key: PresetKey) {
  switch (key) {
    case 'all':
      return 'All vaults'
    case 'tvl':
      return 'TVL > $50M'
    case 'eth':
      return 'ETH yield'
    case 'usd':
      return 'USD yield'
  }
}
